/// <amd-module name="Artifacts/Root/helpers/UrlHelper" />

import { TfsServiceInstanceId } from "Artifacts/Root/Constants";
import * as StringUtils from "VSS/Core/Util/String";
import { IVssPageContext, TeamFoundationHostType } from "VSS/Platform/Context";
import { getServiceLocation } from "VSS/Platform/Location";
import * as Url from "VSS/Platform/Util/Url";

// Did not port over the rest of the file. More helper functions may need to be brought over.
export function getAuditLogUrl(pageContext: IVssPageContext, publicAccessMapping: string): string {
  const tfsUrl = getServiceLocation(
    pageContext,
    TfsServiceInstanceId,
  );

  const auditUrl = Url.combineUrlPaths(tfsUrl, "_settings", "audit");
  return auditUrl;
}

export function isAbsoluteUrl(url: string): boolean {
  if (!url) {
    return false;
  }

  url = url.toLowerCase();
  return url.indexOf("http:") === 0 || url.indexOf("https:") === 0 || url.indexOf("//") === 0;
}

/**
 * Approved list of URL schemes.
 */
export const SafeUriSchemes = [
  "http",
  "https",
  "ftp",
  "gopher",
  "mailto",
  "news",
  "telnet",
  "wais",
  "vstfs",
  "tfs",
  "alm",
  "mtm",
  "mtms",
  "mtr",
  "mtrs",
  "mfbclient",
  "mfbclients",
  "test-runner",
  "x-mvwit",
  "onenote",
  "codeflow",
  "file",
  "tel",
  "skype",
];

/**
 * Check if specified URL is safe - i.e. part of an approved list of URL schemes.
 *
 * @param url Url to check.
 * @returns {boolean}
 */
export function isSafeProtocol(url: string): boolean {
  const trimUrl = url.trim();
  const indexOfSchemeDelimiter = trimUrl.indexOf(":");
  if (indexOfSchemeDelimiter >= 0) {
    const scheme = trimUrl.substr(0, indexOfSchemeDelimiter);
    for (const safeUriScheme of SafeUriSchemes) {
      if (StringUtils.equals(scheme, safeUriScheme, true)) {
        return true;
      }
    }
  }

  return false;
}
